import mapboxgl from 'mapbox-gl';

export function createMap(options) {
    mapboxgl.accessToken = 'pk.eyJ1IjoiZXZlbnRjb25uZWN0b3JzIiwiYSI6ImNsd2k0cWQ1eDAyNGYyamxhYWNqeWdkbjAifQ.JKAzI6Um5WExBDoZYXQN6w';

    return new mapboxgl.Map({
        style: 'mapbox://styles/eventconnectors/clwuexstn015i01qx6afg97vt',
        ...options
    });
}

export function createLandmarks(map, markers, bounds) {
    landmarks.forEach(landmark => {
        const [lat, lng] = landmark.coordinates.split(',').map(parseFloat);
        
        const marker = document.createElement('div');
        marker.className = 'map-landmark';
        marker.dataset.label = landmark.label;

        const label = document.createElement('span');
        label.className = 'map-landmark-label';
        label.textContent = landmark.label;
        marker.appendChild(label);

        markers.push(new mapboxgl.Marker(marker).setLngLat([lng, lat]).addTo(map));
        bounds.extend([lng, lat]);
    });
}